/* eslint-disable max-len */
import React from 'react';
import {Input} from 'semantic-ui-react';
import './styles.scss';

export const Filter = ({column}) => {
  return <div>{column.canFilter && column.render('Filter')}</div>;
};


export const TableFilter = ({'column': {filterValue, setFilter}}) => {
  return (
    <div className='full-width'>
      <Input
        className='input-custom-small'
        value={filterValue || ''}
        onChange={(e) => {
          setFilter(e.target.value || null);
        }}
      />
    </div>
  );
};
